import { createSlice } from "@reduxjs/toolkit";
import { fetchGeoStates, fetchGeoCountiesByState } from "./geoThunk";

const geoSlice = createSlice({
  name: "geo",
  initialState: {
    stateList: [],
    stateLoading: false,
    countyList: [],
    countyListData: [],
    countyLoading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchGeoStates.pending, (state) => {
        state.stateLoading = true;
      })
      .addCase(fetchGeoStates.fulfilled, (state, action) => {
        state.stateLoading = false;
        const sortedStateList = [...action.payload].sort((a, b) =>
          a.label.localeCompare(b.label)
        );
        state.stateList = sortedStateList;
      })
      .addCase(fetchGeoStates.rejected, (state) => {
        state.stateLoading = false;
        state.stateList = [];
      })

      .addCase(fetchGeoCountiesByState.pending, (state) => {
        state.countyLoading = true;
      })
      .addCase(fetchGeoCountiesByState.fulfilled, (state, action) => {
        state.countyLoading = false;
        state.countyList = action.payload.list;
        state.countyListData = action.payload.raw;
      })
      .addCase(fetchGeoCountiesByState.rejected, (state) => {
        state.countyLoading = false;
        state.countyList = [];
        state.countyListData = [];
      });
  },
});

export default geoSlice.reducer;
